// Presence-related constants

// Presence states
export const PRESENCE_STATES = {
  ONLINE: 'online',
  OFFLINE: 'offline', 
  UNAVAILABLE: 'unavailable',
  UNKNOWN: 'unknown',
};

// Presence titles for tooltips
export const PRESENCE_TITLES = {
  ONLINE: 'Online',
  OFFLINE: 'Offline',
  LOADING: 'Loading presence...',
  NO_DATA: 'No presence data',
};

// Presence update intervals (in milliseconds)
export const PRESENCE_INTERVALS = {
  THROTTLE_DELAY: 100,         // Throttle delay for presence updates
  REFRESH_INTERVAL: 30000,     // Refresh presence every 30 seconds
  RETRY_DELAY: 5000,           // Retry failed requests after 5 seconds
};

// Currently active thresholds
export const PRESENCE_THRESHOLDS = {
  CURRENTLY_ACTIVE_MS: 60000,  // Consider user active if last seen within 1 minute
  RECENTLY_ACTIVE_MS: 300000,  // Consider user recently active within 5 minutes
};